import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { EuleGlyph, BieneGlyph, KatzeGlyph, HundGlyph } from "@/components/FokustypGlyphs";

const GLYPH = { eule: EuleGlyph, biene: BieneGlyph, katze: KatzeGlyph, hund: HundGlyph };

export const FreeTypKarte = ({ ergebnis }) => {
  const Glyph = GLYPH[ergebnis.fokustyp];
  return (
    <div data-testid="free-anliegen-typ" data-fokustyp={ergebnis.fokustyp}
      className="rounded-md border border-[#4563BB]/40 dark:border-[#7A92D4] bg-blue-50/50 dark:bg-[#1A2440] p-5">
      <div className="flex items-center gap-3">
        {Glyph && <Glyph size={44} />}
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400">Fokustyp deines Gegenübers</p>
          <h3 data-testid="free-anliegen-typ-name" className="text-lg font-extrabold text-slate-900 dark:text-white">{ergebnis.fokustyp_name}</h3>
        </div>
      </div>
      <p data-testid="free-anliegen-begruendung" className="mt-3 text-sm text-slate-700 dark:text-slate-200 leading-relaxed">{ergebnis.begruendung}</p>
    </div>
  );
};

export const FreeTippKarte = ({ tipp }) => (
  <div data-testid="free-anliegen-tipp"
    className="bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-800/60 rounded-md p-5">
    <p className="text-xs font-bold uppercase tracking-widest text-emerald-700 dark:text-emerald-300 mb-2">Das kannst du direkt ausprobieren</p>
    <h3 data-testid="free-anliegen-tipp-kernidee" className="text-base sm:text-lg font-extrabold tracking-tight text-slate-900 dark:text-white">{tipp.kernidee}</h3>
    <p data-testid="free-anliegen-tipp-text" className="mt-2 text-sm text-slate-700 dark:text-slate-200 leading-relaxed">{tipp.text}</p>
    <Link to="/dashboard/abo" data-testid="free-anliegen-weitere-ansaetze"
      className="mt-4 inline-flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 transition-colors">
      <Lock className="w-3 h-3" /> Weitere Ansätze auf dieser Ebene – in Pro Solo freigeschaltet
    </Link>
  </div>
);

export const FreeUnklarHinweis = ({ hinweis }) => (
  <div data-testid="free-anliegen-unklar"
    className="rounded-md border border-amber-200 dark:border-amber-800/60 bg-amber-50 dark:bg-amber-950/40 p-5 text-sm text-amber-900 dark:text-amber-100 leading-relaxed">
    {hinweis}
  </div>
);
